import { render, staticRenderFns } from "./form-modal.vue?vue&type=template&id=78067081&scoped=true&"
import script from "./form-modal.vue?vue&type=script&lang=js&"
export * from "./form-modal.vue?vue&type=script&lang=js&"
import style0 from "./form-modal.vue?vue&type=style&index=0&id=78067081&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78067081",
  null
  
)

export default component.exports